import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobNote, UpdateJobNoteRequest } from "@/types";

export function useUpdateJobNote() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      jobNoteId,
      updateJobNoteRequest,
    }: {
      jobNoteId: number;
      updateJobNoteRequest: UpdateJobNoteRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-notes/${jobNoteId.toString()}`;
      const res = await guacHttpClient.patch<
        JobNote,
        HttpResponse<JobNote>,
        UpdateJobNoteRequest
      >(path, updateJobNoteRequest);

      return res.data;
    },
  });

  return mutation;
}
